<unclaimed-message [task]="task" (claimed)="getTask($event.id)"></unclaimed-message>
@if (task?.purchaseRequisition) {
    <purchase-requisition-detail
        [purchaseRequisition]="task.purchaseRequisition"
        [editingWithDialog]="true"
        [task]="task"
        #purchaseRequisitionDetailComponent
    >
        <div class="row justify-content-end mb-2">
            <div class="col-auto">
                <task-hint-display [hint]="task.hint"></task-hint-display>
            </div>
        </div>
        <div class="row justify-content-end mb-2" *removeIfUnclaimed="task">
            <div class="col-auto">
                <div class="btn-group">
                    <button class="btn btn-warning" (click)="withdraw()">
                        <em class="fas fa-delete-left pe-1"></em>
                        {{ 'Bedarfsmeldung zurückziehen' | translate }}
                    </button>
                    <button class="btn btn-primary" (click)="save()" [disabled]="completionBlocked">
                        <em class="fas fa-floppy-disk pe-1"></em>
                        {{ 'speichern' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </purchase-requisition-detail>
}
